var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M5.785 2.652l1.254-1.254c.53-.53 1.391-.53 1.922 0l1.254 1.254h1.774c.75 0 1.359.609 1.359 1.36v1.773l1.254 1.254c.53.53.53 1.391 0 1.922l-1.254 1.254v1.774c0 .75-.609 1.359-1.36 1.359h-1.773l-1.254 1.254c-.53.53-1.391.53-1.922 0l-1.254-1.254H4.01c-.75 0-1.359-.609-1.359-1.36v-1.773L1.398 8.961a1.359 1.359 0 0 1 0-1.922l1.254-1.254V4.01c0-.75.609-1.359 1.36-1.359h1.773zM6.03 7.97a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06 0l4-4a.75.75 0 0 0-1.06-1.06L7 8.94l-.97-.97z" })
  );
});